export default "__VITE_ASSET__Bs8Wi$ld__"